import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Student } from '../Models/student';
import { StudentService } from '../Service/student.service';
import { Attend } from '../Models/attend';
import { AttendStudentService } from '../Service/attend-student.service';

@Component({
  selector: 'app-attendance-student',
  templateUrl: './attendance-student.component.html',
  styleUrls: ['./attendance-student.component.css']
})
export class AttendanceStudentComponent implements OnInit {

  student: Student;
  errmsg = "";
  sign: boolean;
  // Inject Service
  constructor(
    private studentService: StudentService,
    private AttendService: AttendStudentService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    // Get student status and name when the page initialize
    this.route.paramMap
      .switchMap((params: ParamMap) => this.studentService.getStudentbyPin(params.get('id')))
      // .switchMap((params: ParamMap) => this.studentService.getStudent())
      .subscribe(student => {
        this.student = student[0][0];
        this.sign = Boolean(this.student.sign);
      });
  }

  // Check in event
  checkIn(){
    this.addCheckIn();
  }

  // Check out event
  checkOut(){
    this.addCheckOut();
  }

  // Add new check In
  addCheckIn() {
    // Format datetime
    let _now = new Date();
    let month = this.getMonth(_now);
    let day = this.getDay(_now);
    let hour = this.getHours(_now);
    let min = this.getMinutes(_now);
    let sec = this.getSeconds(_now);

    // Get new check in time, school id and student id.
    let checkin = new Attend();
    checkin.stime = _now.getFullYear() + "-" + month + "-" + day
      + " " + hour + ":" + min + ":" + sec;
    checkin.sid = this.student.id;
    checkin.school = Number(localStorage.getItem('school'));

    // Call api to add new check in attendance
    this.AttendService.addCheckIn(checkin)
    .subscribe(
      () => this.router.navigate(['/attendance']),
      err => {
        this.errmsg = 'Failure to check in, please try again';
        console.log(err);
      }
    );
  }

  // Add new check out
  addCheckOut() {
    // Format the datatime
    let _now = new Date();
    let month = this.getMonth(_now);
    let day = this.getDay(_now);
    let hour = this.getHours(_now);
    let min = this.getMinutes(_now);
    let sec = this.getSeconds(_now);

    // Get check out time, school id and student id
    let checkout = new Attend();
    checkout.etime = _now.getFullYear() + "-" + month + "-" + day
      + " " + hour + ":" + min + ":" + sec;
    checkout.sid = this.student.id;
    checkout.school = Number(localStorage.getItem('school'));

    // Call api to add check out attendance
    this.AttendService.addCheckOut(checkout)
      .subscribe(
        () => this.router.navigate(['/attendance']),
        err => {
          this.errmsg = 'Failure to check out, please try again';
          console.log(err);
        }
      );

  }

  // Format Seconds
  private getSeconds(date) {
    var sec = date.getSeconds();
    return sec < 10 ? '0' + sec : '' + sec;  // ('' + sec) for string result
  }
  // Formate Minutes
  private getMinutes(date) {
    var min = date.getMinutes();
    return min < 10 ? '0' + min : '' + min;  // ('' + min) for string result
  }
  // Formate Hours
  private getHours(date){
    var hour = date.getHours();
    return hour < 10 ? '0' + hour : '' + hour;  // ('' + hour) for string result
  }
  // Formate Days
  private getDay(date) {
    var day = date.getDate();
    return day < 10 ? '0' + day : '' + day; // ('' + day) for string result
  }
  // Formate Month
  private getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
  }


}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/attendance-student/attendance-student.component.ts